export default __webpack_public_path__ + "static/media/factory__30.ded98a83.jpg";